import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false, allowEmails = null }) {
    const { user } = useAuth();

    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <Loader2 className="w-6 h-6 animate-spin text-primary" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/" replace />;
    }

    // Restrição por lista de e-mails (admin sempre passa)
    if (allowEmails && user.role !== "admin" && !allowEmails.includes(user.email)) {
        return <Navigate to="/" replace />;
    }

    return children;
}
